import { $, w } from './constants';

let page = 0;

function getPageSize() {
    if (window.innerWidth <= 768) return 12;
    if (window.innerWidth <= 1024) return 10;
    return 12;
}

function getChips() {
    return $('.fichas__chips .chip');
}

function getVisible() {
    const size = getPageSize();
    return getChips().slice(page * size, page * size + size);
}

function renderChips() {
    const size = getPageSize();
    const all = getChips();
    const start = page * size;
    const end = start + size;

    all.each(function(i) {
        $(this).css('display', (i >= start && i < end) ? 'flex' : 'none');
    });

    $('#prev').prop('disabled', page === 0);
    $('#next').prop('disabled', end >= all.length);
}

function renderCards(fichas, fecha) {
    const label = $('.chip[data-fecha="' + fecha + '"]').text().trim();

    const cards = fichas.map(f => `
        <div class="ficha">
            <a href="${f.imagen}" target="_blank">
                <img class="ficha__imagen" src="${f.imagen}" alt="${f.nombre}">
            </a>
            <div class="ficha__cuerpo">
                <a class="ficha__nombre" href="${f.imagen}" target="_blank">${titleCase(f.nombre)}</a>
            </div>
        </div>
        <hr>
    `).join('');

    $('.fichas-wrapper__fecha').html(label);
    $('.fichas-grupo').html(cards);
}

function loadFichas(fecha) {
    $.post(ajaxurl, {
        action: 'get_fichas_por_fecha',
        fecha: fecha
    }, function(response) {
        if (!response.success) return;
        renderCards(response.data, fecha);
    });
}

function selectFecha(fecha) {
    getChips().removeClass('active btn btn--purple-ic').filter(`[data-fecha="${fecha}"]`).addClass('active btn btn--purple-ic');
    loadFichas(fecha);
}

export function initFichas() {
    const firstDate = getChips().first().data('fecha');
    if (firstDate) loadFichas(firstDate);

    renderChips();

    $(document).on('click', '.chip', function () {
        selectFecha($(this).data('fecha'));
    });

    $('#prev').on('click', () => { page--; renderChips(); });
    $('#next').on('click', () => { page++; renderChips(); });
}

function titleCase(str) {
    return str.toLowerCase().split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
}